import {hexColorToRGBA} from '@/views/chart/chart/util'
import {componentStyle} from '../common/common'
import {BASE_ECHARTS_SELECT, DEFAULT_TOOLTIP} from '@/views/chart/chart/chart'
import isNumber from 'lodash/isNumber'
import { getStrByLang } from '@/utils'

export function baseFunnelTriangleOption(chart_option, chart) {
  // 处理shape attr
  let customAttr = {}
  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      // const reg = new RegExp('\n', 'g')
      // tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      // 为了显示真实数值，提示框的格式写死
      tooltip.formatter = (params) => {
        let formatter = `<b>${params.name}</b> ${params.marker} ${params.data.realValue}`
        if (tooltip.calcConversionRate && params.data.conversionRate) {
          formatter += `<br/><br/><b>转化率</b>\t${params.data.conversionRate}`
        }
        return formatter
      }
      chart_option.tooltip = tooltip

      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }
  // 处理data
  if (chart.data) {
    chart_option.title.text = chart.title
    if (chart.data.series.length > 0) {
      chart_option.series[0].name = getStrByLang(chart.data.series[0].name)
      // size
      if (customAttr.size) {
        chart_option.series[0].width = customAttr.size.funnelWidth + '%'
        if (isNumber(customAttr.size.funnelMinSize)) {
          chart_option.series[0].minSize = customAttr.size.funnelMinSize + "%"
        }
        if (isNumber(customAttr.size.funnelMaxSize)) {
          chart_option.series[0].maxSize = customAttr.size.funnelMaxSize + "%"
        }
        if (customAttr.size.sort) {
          chart_option.series[0].sort = customAttr.size.sort
        }
        if (isNumber(customAttr.size.min)) {
          chart_option.series[0].min = customAttr.size.min
        }
        if (isNumber(customAttr.size.max)) {
          chart_option.series[0].max = customAttr.size.max
        }
      }

      // label
      if (customAttr.label) {
        chart_option.series[0].label = customAttr.label
      }
      // 为了显示真实数值，标签的格式写死
      chart_option.series[0].label.formatter = (data) => {
        return `${data.data.realValue || data.value}`
      }

      const valueArr = [...chart.data.series[0].data]
      // 先填充值对应的属性名称再排序
      valueArr.forEach((y, i) => {
        y.name = getStrByLang(chart.data.x[i])
      })
      valueArr.sort((a, b) => {
        return a.value - b.value
      })

      let max = 100;
      for (let i = 0; i < valueArr.length; i++) {
        const y = valueArr[i]
        y.itemStyle = {
          color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha)
        }
        y.selectedMode = true
        y.select = BASE_ECHARTS_SELECT
        max = Math.max(max, y.value)
        // 存储真实数值
        if (!y.hasOwnProperty("realValue")) {
          y.realValue = y.value
        }

        // 绘制图形用的数值等比例增长
        y.value = 20 * (i + 1)
        chart_option.series[0].data.push(y)
      }

      // 存储转化率
      if (customAttr.tooltip.calcConversionRate && valueArr.length > 0) {
        const maxValue = valueArr[valueArr.length - 1].realValue
        for (let i = 0; i < valueArr.length - 1; i++) {
          valueArr[i].conversionRate = ((valueArr[i].realValue / maxValue) * 100).toFixed(2) + "%"
        }
      }

      // 让漏斗图变为三角形的关键配置
      chart_option.series[0].min = 0
      chart_option.series[0].max = (valueArr.length + 1) * 20
    }
  }
  componentStyle(chart_option, chart)

  return chart_option
}

